import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

// `source` is carried on the attempt so the unified drawer renders the right
// detail panel and resolves the right reference IDs. Modeled as a
// `source`-discriminated union nested in the `type`-keyed TaskAttempt union —
// both arms share the same `type` literal.
export const CreateVendorCreditsSource = {
  APPEASEMENT: "APPEASEMENT",
  CORRECTIONS_WORK_ORDER: "CORRECTIONS_WORK_ORDER",
} as const;

export const CreateVendorCreditsTaskAttemptSchema = z.discriminatedUnion("source", [
  z.object({
    type: z.literal(TaskType.CREATE_VENDOR_CREDITS),
    source: z.literal(CreateVendorCreditsSource.APPEASEMENT),
    appeasementId: z.string().min(1),
    bidId: z.number().int().positive(),
  }),
  z.object({
    type: z.literal(TaskType.CREATE_VENDOR_CREDITS),
    source: z.literal(CreateVendorCreditsSource.CORRECTIONS_WORK_ORDER),
    projectId: z.number().int().positive(),
  }),
]);

export type CreateVendorCreditsTaskAttempt = z.infer<typeof CreateVendorCreditsTaskAttemptSchema>;

export type CreateVendorCreditsSourceValue = (typeof CreateVendorCreditsSource)[keyof typeof CreateVendorCreditsSource];

// Deliberately narrower than the full union above: a read path that only buckets by
// source must not reject an attempt because a per-source reference field drifted.
export const CreateVendorCreditsAttemptSourceSchema = z.object({
  source: z.enum(CreateVendorCreditsSource),
});
